"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextCellWithTooltip = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var TextCellWithTooltip = function (props) {
    var _a = props.cell.value, text = _a.text, tooltipMessage = _a.tooltipMessage, _b = _a.showTooltip, showTooltip = _b === void 0 ? false : _b;
    return showTooltip && tooltipMessage ? (react_1.default.createElement(storm_ui_1.Tooltip, { message: tooltipMessage, position: "right", withCloseButton: true, trigger: react_1.default.createElement(storm_ui_1.Text, null, text) })) : (react_1.default.createElement(storm_ui_1.Text, null, text));
};
exports.TextCellWithTooltip = TextCellWithTooltip;
